/**
 * Sair devolve a pessoa à MESMA porta por onde entrou.
 *
 * Antes todo botão "Sair" mandava para `/entrar` fixo. Quem tinha entrado por
 * `/entrar/<slug>` caía na porta da Eva ao sair — e, para entrar de novo,
 * precisava lembrar o endereço.
 *
 * O caminho é derivado, não guardado: se o hostname já resolve a marca
 * (subdomínio, o desenho de produção), `/entrar` puro basta porque o endereço
 * carrega a informação. Só o dash-slug precisa do slug de volta no caminho.
 */
import { caminhoDeEntrada } from '@eva/domain';
import { marcaDetectada } from '../marca-detectada';

export function caminhoDeSaida(slugDaMarca?: string | null): string {
  return caminhoDeEntrada({
    slug: slugDaMarca ?? null,
    hostResolveAMarca: marcaDetectada.source === 'subdomain',
  });
}
